```vue
<template>
  <el-dialog
    title="编辑配送邮费模版"
    :visible.sync="visible"
    width="600px"
    append-to-body
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="120px"
    >
      <el-form-item label="邮费模版名称" prop="name">
        <el-input
          v-model="form.name"
          placeholder="请输入名称"
          style="width: 240px"
        />
      </el-form-item>

      <el-form-item label="省份" prop="city">
        <el-select
          v-model="form.city"
          style="width: 240px"
          multiple
          placeholder="请选择"
        >
          <el-option
            v-for="item in cityList"
            :key="item.id"
            :label="item.name"
            :value="item.code"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="首重(KG)" prop="first_number">
        <el-input
          v-model="form.first_number"
          placeholder="请输入"
          style="width: 240px"
          @input="handleInput"
        />
      </el-form-item>

      <el-form-item label="首重价格(韩元)" prop="first_amount">
        <el-input
          v-model="form.first_amount"
          placeholder="请输入"
          style="width: 240px"
          @input="handleInput"
        />
      </el-form-item>

      <el-form-item label="续重(KG)" prop="repeat_number">
        <el-input
          v-model="form.repeat_number"
          placeholder="请输入"
          style="width: 240px"
          @input="handleInput"
        />
      </el-form-item>

      <el-form-item label="续重价格(韩元)" prop="repeat_amount">
        <el-input
          v-model="form.repeat_amount"
          placeholder="请输入"
          style="width: 240px"
          @input="handleInput"
        />
      </el-form-item>

      <el-form-item label="创建时间" prop="add_time">
        <el-input
          v-model="form.add_time"
          disabled
          style="width: 240px"
        />
      </el-form-item>
    </el-form>

    <div slot="footer">
      <el-button @click="handleClose">
        返 回
      </el-button>

      <el-button
        type="primary"
        :loading="submitLoading"
        @click="submitForm"
      >
        保 存
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  getCityList
} from '@/api/postage'

import {
  goodsPostageDetail,
  goodsPostageUpdate
} from '@/api/xgcApi'

export default {
  name: 'EditPostageDialog',

  props: {
    value: {
      type: Boolean,
      default: false
    },

    editId: {
      type: [String, Number],
      default: null
    },

    postId: {
      type: [String, Number],
      default: null
    }
  },

  data() {
    return {
      cityList: [],
      cityForm: {},

      submitLoading: false,

      form: {
        id: null,
        post_id: null,
        city: [],
        cityCode: '',
        express_type: null,
        express_type1: null,

        name: '',
        first_number: '',
        first_amount: '',
        repeat_number: '',
        repeat_amount: '',
        add_time: '',

        type: null,

        kfh_first_number: '',
        kfh_first_amount: '',
        kfh_repeat_number: '',
        kfh_repeat_amount: ''
      },

      rules: {
        name: [
          {
            required: true,
            message: '邮费模版名称不能为空',
            trigger: 'blur'
          }
        ],

        express_type: [
          {
            required: true,
            message: '请选择快递方式',
            trigger: 'change'
          }
        ],

        city: [
          {
            required: true,
            message: '省份不能为空',
            trigger: 'change'
          }
        ],

        type: [
          {
            required: true,
            message: '类型不能为空',
            trigger: 'blur'
          }
        ],

        first_number: [
          {
            required: true,
            message: '首重不能为空',
            trigger: 'blur'
          },
          {
            pattern: /^(0|[1-9]\d*)(\.\d+)?$/,
            message: '请输入数字或小数',
            trigger: 'blur'
          }
        ],

        first_amount: [
          {
            required: true,
            message: '首重价格不能为空',
            trigger: 'blur'
          },
          {
            pattern: /^[0-9]+(\.[0-9]{0,9})?$/,
            message: '价格只能为数字和小数',
            trigger: 'blur'
          }
        ],

        repeat_number: [
          {
            required: true,
            message: '续重不能为空',
            trigger: 'blur'
          },
          {
            pattern: /^(0|[1-9]\d*)(\.\d+)?$/,
            message: '请输入数字或小数',
            trigger: 'blur'
          }
        ],

        repeat_amount: [
          {
            required: true,
            message: '续重价格不能为空',
            trigger: 'blur'
          },
          {
            pattern: /^(0|[1-9]\d*)(\.\d+)?$/,
            message: '请输入数字或小数',
            trigger: 'blur'
          }
        ],

        kfh_first_number: [
          {
            required: true,
            message: 'khf首重不能为空',
            trigger: 'blur'
          },
          {
            pattern: /^(0|[1-9]\d*)(\.\d+)?$/,
            message: '请输入数字或小数',
            trigger: 'blur'
          }
        ],

        kfh_first_amount: [
          {
            required: true,
            message: 'khf首重价格不能为空',
            trigger: 'blur'
          },
          {
            pattern: /^(0|[1-9]\d*)(\.\d+)?$/,
            message: '请输入数字或小数',
            trigger: 'blur'
          }
        ],

        kfh_repeat_number: [
          {
            required: true,
            message: 'khf续重不能为空',
            trigger: 'blur'
          },
          {
            pattern: /^(0|[1-9]\d*)(\.\d+)?$/,
            message: '请输入数字或小数',
            trigger: 'blur'
          }
        ],

        kfh_repeat_amount: [
          {
            required: true,
            message: 'khf续重价格不能为空',
            trigger: 'blur'
          },
          {
            pattern: /^(0|[1-9]\d*)(\.\d+)?$/,
            message: '请输入数字或小数',
            trigger: 'blur'
          }
        ]
      }
    }
  },

  computed: {
    visible: {
      get() {
        return this.value
      },

      set(val) {
        this.$emit('input', val)
      }
    }
  },

  watch: {
    value(val) {
      if (val) {
        this.init()
      }
    }
  },

  methods: {
    async init() {
      this.resetForm()

      this.form.id = this.editId
      this.form.post_id = this.postId

      await Promise.all([
        this.list(),
        this.showEdit()
      ])
    },

    async list() {
      try {
        const {
          data
        } = await getCityList(this.cityForm)

        this.cityList = data || []
      } catch (error) {
        console.log(error)
      }
    },

    async showEdit() {
      if (!this.editId) {
        return
      }

      try {
        const {
          data
        } = await goodsPostageDetail({
          id: this.editId,
          post_id: this.postId
        })

        this.form = {
          ...this.form,
          ...data
        }

        this.form.id = this.editId

        if (!this.form.post_id) {
          this.form.post_id = this.postId
        }

        if (data.city) {
          this.form.city = String(data.city)
            .trim()
            .split(',')
            .filter(item => item !== '')
            .map(item => Number(item))
        } else {
          this.form.city = []
        }
      } catch (error) {
        console.log(error)
      }
    },

    handleInput() {
      const fields = [
        'first_number',
        'first_amount',
        'repeat_number',
        'repeat_amount',
        'kfh_first_number',
        'kfh_first_amount',
        'kfh_repeat_number',
        'kfh_repeat_amount'
      ]

      fields.forEach(key => {
        if (
          this.form[key] === null ||
          this.form[key] === undefined
        ) {
          this.form[key] = ''
          return
        }

        this.form[key] = String(this.form[key])
          .replace(/[^\d.]/g, '')
          .replace(/^(\d*\.)|(\.)/g, (match, first) => {
            return first || ''
          })
          .replace(/^0+(\d)/, '$1')
      })
    },

    submitForm() {
      this.$refs.form.validate(async valid => {
        if (!valid) {
          return false
        }

        this.submitLoading = true
console.log(this.form,'78787987')
        try {
          this.form.cityCode = this.form.city.join(',')


          const submitData = {
            ...this.form
          }

console.log(submitData,'789789798')


          delete submitData.city

          await goodsPostageUpdate(submitData)

          this.$message.success('修改成功')

          this.$emit('success')

          this.handleClose()
        } catch (error) {
          console.log(error)
        } finally {
          this.submitLoading = false
        }
      })
    },

    handleClose() {
      this.$emit('input', false)
      this.$emit('close')
    },

    resetForm() {
      this.form = {
        id: this.editId,
        post_id: this.postId,
        city: [],
        cityCode: '',
        express_type: null,
        express_type1: null,

        name: '',
        first_number: '',
        first_amount: '',
        repeat_number: '',
        repeat_amount: '',
        add_time: '',

        type: null,

        kfh_first_number: '',
        kfh_first_amount: '',
        kfh_repeat_number: '',
        kfh_repeat_amount: ''
      }

      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
    }
  }
}
</script>

<style scoped>
.el-form {
  padding: 10px 20px 0;
}
</style>
